
import React from 'react';
import QuizContent from '../QuizContent';
import QuizFooter from './QuizFooter';

interface ModalContentProps {
  content: string;
  hasQuiz: boolean;
  questions: any[];
  userAnswers: Record<string, string[]>;
  quizSubmitted: boolean;
  quizPassed: boolean;
  score: number;
  minScore: number;
  attemptNumber: number;
  maxAttempts: number | null;
  attemptsExhausted: boolean;
  currentQuestionIndex: number;
  onAnswer: (questionId: string, selectedOptions: string[]) => void;
  onSubmit: () => void;
  onReset: () => void;
  onPrevQuestion: () => void;
  onNextQuestion: () => void;
  hasSelectedOptions?: boolean;
}

const ModalContent: React.FC<ModalContentProps> = ({
  content,
  hasQuiz,
  questions,
  userAnswers,
  quizSubmitted,
  quizPassed,
  score,
  minScore,
  attemptNumber,
  maxAttempts,
  attemptsExhausted,
  currentQuestionIndex,
  onAnswer,
  onSubmit,
  onReset,
  onPrevQuestion,
  onNextQuestion,
  hasSelectedOptions = false,
}) => {
  // Enhanced content styling for better readability that matches the preview
  const enhancedContent = content
    // Proper paragraph styling
    .replace(/<p>/g, '<p style="margin-bottom: 1rem; line-height: 1.6; white-space: normal;">')
    // Ensure headers are well-styled
    .replace(/<h(\d)>/g, '<h$1 style="margin-top: 1.5rem; margin-bottom: 1rem; font-weight: bold; white-space: normal;">')
    // Image styling
    .replace(/<img /g, '<img style="max-width: 100%; height: auto; margin: 1rem 0; border-radius: 8px;" ')
    // Iframe (PDF) styling
    .replace(/<iframe /g, '<iframe style="width: 100%; height: 500px; margin: 1rem 0; border: none; border-radius: 8px;" ')
    // List items
    .replace(/<ul>/g, '<ul style="padding-left: 1.5rem; margin-bottom: 1rem; white-space: normal;">')
    .replace(/<ol>/g, '<ol style="padding-left: 1.5rem; margin-bottom: 1rem; white-space: normal;">')
    .replace(/<li>/g, '<li style="margin-bottom: 0.5rem; white-space: normal;">');
  
  return (
    <div className="space-y-6">
      <div className="mb-6">
        <div 
          className="prose dark:prose-invert max-w-none overflow-auto whitespace-normal"
          dangerouslySetInnerHTML={{ __html: enhancedContent }} 
        />
      </div>
      
      {hasQuiz && (
        <div className="border rounded-md p-4 mb-4">
          <QuizContent
            questions={questions}
            userAnswers={userAnswers}
            onAnswer={onAnswer}
            quizSubmitted={quizSubmitted}
            quizPassed={quizPassed}
            score={score}
            minScore={minScore}
            attemptNumber={attemptNumber}
            maxAttempts={maxAttempts}
            attemptsExhausted={attemptsExhausted}
            currentQuestionIndex={currentQuestionIndex}
          />
          
          {questions.length > 0 && (
            <QuizFooter
              quizSubmitted={quizSubmitted}
              quizPassed={quizPassed}
              questions={questions}
              hasSelectedOptions={hasSelectedOptions}
              currentQuestionIndex={currentQuestionIndex}
              onPrevQuestion={onPrevQuestion}
              onNextQuestion={onNextQuestion}
              onSubmit={onSubmit}
              onReset={onReset}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default ModalContent;
